<script setup lang="ts">
  // Extracted verbatim from PosV2Cart.vue's footer so the comment block can
  // render inline (tier < 2) or inside the Comentario chip popover (tier 2).
  import { computed } from 'vue';
  import { usePosDraftsStore } from '@/stores/pos-drafts.store';
  import PosUiIcon from '@/components/pos-v2/ui/PosUiIcon.vue';
  import PosUiTextarea from '@/components/pos-v2/ui/PosUiTextarea.vue';

  withDefaults(
    defineProps<{
      rows?: number;
    }>(),
    {
      rows: 2,
    }
  );

  const posDrafts = usePosDraftsStore();

  const draft = computed(() => posDrafts.activeDraft);

  const userComment = computed({
    get: () => draft.value?.userComment ?? '',
    set: (value: string) => {
      if (!draft.value) return;
      posDrafts.updateDraft(draft.value.id, { userComment: value });
    },
  });
</script>

<template>
  <div class="order-comment">
    <label class="comment-label">
      <PosUiIcon name="message-text-outline" />
      <span>{{ $t('posV2.orderComments') }}</span>
      <span class="optional">{{ $t('posV2.optional') }}</span>
    </label>
    <PosUiTextarea
      :value="userComment"
      :placeholder="$t('posV2.orderCommentsPlaceholder')"
      :rows="rows"
      :maxlength="140"
      @input="(v) => (userComment = v)"
    />
  </div>
</template>

<style scoped lang="scss">
  .order-comment {
    @apply tw-flex tw-flex-col tw-gap-1.5;

    .comment-label {
      @apply tw-flex tw-items-center tw-gap-1.5 tw-text-xs tw-font-medium tw-text-neutral-700;

      .optional {
        @apply tw-text-[10px] tw-font-normal tw-text-neutral-500;
      }
    }
  }
</style>
